"use strict";

angular.module("models").service("SyncConfigsService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("SyncConfigs", ["name"], function (element) {
    return "???";
  }));
}]);